import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';
import { Store } from '@ngrx/store';
import { loadServices, loadSubpages, setUISettings } from './store/actions/app.actions';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    CommonModule,
    RouterOutlet
  ],
  template: `
    <router-outlet/>
  `,
  providers: []
})
export class AppComponent {

  private url: URL = new URL(window.location.href);

  private embed = this.url.searchParams.get('embed');

  constructor(
    private store$: Store
  ) {
    this.store$.dispatch(loadServices());
    this.store$.dispatch(loadSubpages());
    this.handleRouteParams();
  }

  private handleRouteParams(): void {
    if (this.embed) {
      this.store$.dispatch(
        setUISettings({
          uiSettings: {
            mobileEmbed: true,
            application: {
              hideTitle: false
            }
          }
        })
      );
    }
  }

}
